export default __webpack_public_path__ + "static/media/aip.35791b7d.svg";